export var getGameName = function (game) {
    if (!game)
        return '';
    var name = game.name, tournament = game.tournament;
    var groupName = game === null || game === void 0 ? void 0 : game.groupName;
    var marketingName = game === null || game === void 0 ? void 0 : game.marketingName;
    if (groupName)
        return groupName;
    if (tournament)
        return tournament;
    if (marketingName)
        return marketingName;
    return name;
};
